import { useEffect, useRef, useState } from 'react';

/** Hide the pinned CTA while any `[data-offer-cta]` is in the viewport. */
export function useStickyCta(resetKey: unknown) {
  const rootRef = useRef<HTMLDivElement>(null);
  const [stickyHidden, setStickyHidden] = useState(false);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const targets = root.querySelectorAll('[data-offer-cta]');
    if (!targets.length) return;

    const visible = new Set<Element>();
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        setStickyHidden(visible.size > 0);
      },
      { rootMargin: '0px 0px -80px 0px' },
    );
    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
  }, [resetKey]);

  return { rootRef, stickyHidden };
}
